import { LocationsEnum } from '../../enums';

export const mapTabLocations = (tabIndex: number): LocationsEnum | undefined => {
  switch (tabIndex) {
    case 0: {
      return undefined;
    }
    case 1: {
      return LocationsEnum.HQ;
    }
    case 2: {
      return LocationsEnum.AgencyNetwork;
    }
    default: {
      return undefined;
    }
  }
};
